import { api, helpers } from "../../../utils";
const cafe = {
    sms: {
        session_timeout: api.sms.session_timeout,
        invalid_inputs: api.sms.invalid_inputs,
        contact_admin: api.sms.contact_admin,
    },
};
const hlog = helpers.html.log;
const tRemove = helpers.text.remove;

const exportData = async (_, payload) => {
    let p = new Promise(async (resolve) => {
        if (!payload || !payload.fileName) return resolve({ error: cafe.sms.invalid_inputs });
        hlog.start("excel.export", "start", payload);
        const res_export = await api.node.cross.export.excel(payload);
        let blodData = res_export.data;
        helpers.html.download.blob({ data: blodData, fileName: payload.fileName });
        hlog.end("excel.export", "end", payload.fileName);
        resolve({ is_success: true, data: res_export });
    });

    return p;
};

const read = async (_, payload) => {
    let p = new Promise(async (resolve) => {
        const { key, file } = payload;
        let formData = new FormData();
        let arr = file.name.split(".");
        let extname = arr.pop();
        let fileName = arr.join(".");
        fileName = `${tRemove.diacritics(fileName)}.${extname}`;
        formData.append(key, file, fileName);
        let error = cafe.sms.contact_admin;
        hlog.start("excel.read", "start", fileName);
        const res = await api.node.origin.excel.read(formData);
        hlog.end("excel.read", "end", res);
        if (!res || !Array.isArray(res.data)) resolve({ error });
        else resolve(res);
    });

    return p;
};

export default {
    read,
    exportData,
};



// WEBPACK FOOTER //
// src/store/views/excel/actions.js